import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getStaffRole = createAsyncThunk('profileSettings/getStaffRole', async () => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetStaffRoleTypeList')
      return response.data
   })
  
   export const getData = createAsyncThunk('profileSettings/getData', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/GetTableSummary', params, {mode:'cors'})
      return {
         params,
         data: response.data
      }
   })

   export const getUsers = createAsyncThunk('profileSettings/getUsers', async (params) => {
         
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/GetUsers', params, {mode:'cors'})
       
      return {
         params,
         data: response.data
      }
   })

   export const UploadImage = createAsyncThunk('profileSettings/UploadImage', async (formData) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageProfile', formData, {mode:'cors'})
      return response
   })

   export const getProfileImage = createAsyncThunk('profileSettings/getProfileImage', async (profile) => {
       
      const response = await axios.post('https://api.zasway.com:8443/Common/GetProfileImage', profile, {mode:'cors'})
      return response.data
    })

    export const getProfileImages = createAsyncThunk('profileSettings/getProfileImages', async (profile) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetProfileImages', profile, {mode:'cors'})
      return response.data
    })
   
   export const addProfileSettings = createAsyncThunk('profileSettings/addProfileSettings', async (Basic) => {
      
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/Create', Basic, {mode:'cors'})
      
      return response
   })

   export const addPassword = createAsyncThunk('profileSettings/addPassword', async (Password) => {
      
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/UpdatePassword', Password, {mode:'cors'})
      
      return response
   })

   export const editPassword  = createAsyncThunk('profileSettings/editPassword', async (Password) => {
       
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/UpdatePassword', Password, {mode:'cors'})
       
      return response
   })

   export const editProfileSettings  = createAsyncThunk('profileSettings/editProfileSettings', async (Edit) => {
      
      const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/Update', Edit, {mode:'cors'})
      
      return response
   })

   export const resetPasswordEditData = createAsyncThunk('profileSettings/resetPasswordEditData', async () => {
      
      return {
        data: []
      }
    })

export const profileSettingsSlice = createSlice({
   name: 'profileSettings',
   initialState: {
      profileSettingsEditData: [],
      ProfileUserData: [],
      ProfileEditData: [],
      profImg: [],
      passwordEditData: []
   },
   reducers: {},
   extraReducers: builder => {
   builder

      .addCase(getData.fulfilled, (state, action) => {
         state.ProfileEditData = action.payload.data
      })
         
      .addCase(getUsers.fulfilled, (state, action) => {
          
         state.ProfileUserData = action.payload.data
      })

      .addCase(getProfileImages.fulfilled, (state, action) => {
         state.profImg = action.payload
      })
      
      .addCase(editProfileSettings.fulfilled, (state, action) => {
         state.profileSettingsEditData = action.payload.data
      })

      .addCase(resetPasswordEditData.fulfilled, (state, action) => {
         
         state.passwordEditData = action.payload.data
       })
   }
})
   
 export default profileSettingsSlice.reducer